module.exports = __webpack_public_path__ + "static/media/img-680b0217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/marionhealth-logo.png
// module id = 5292
// module chunks = 39